import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Button, ConfirmDialog, TextField } from "@bookips/solvook-ui-library";
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Stack, styled, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import Icon from "../icon/Icon";
import { Close, Sizes } from "../icon/IconList";
import AnchorDrawer from "../modal/AnchorDrawer";
import { CancelReasonValue } from "./SubscribeButton";
export const SubscribeCancelDialog = (param)=>{
    let { open , close , value , setValue , handleSubmit  } = param;
    const { isMobile  } = useWindowDimensions();
    const isEtc = useMemo(()=>value === CancelReasonValue[5], [
        value
    ]);
    const [etcReason, setEtcReason] = useState("");
    const [isError, setIsError] = useState(false);
    const submit = ()=>{
        if (isEtc && !etcReason) {
            //TODO 기타를 입력하지 않았을때.
            setIsError(true);
            return;
        }
        handleSubmit(etcReason);
        //mx-9 소식 받기 해지 dialog 내 버튼 클릭 시
        mixpanelEvent("Popup Button Clicked", {
            "Popup Type": "Brand Unsubscription",
            "Popup Title": "소식 받기를 해지하시겠어요?",
            "Button Name": "소식 받지 않기",
            Reason: etcReason
        });
    };
    const content = {
        open: open,
        close: close,
        title: /*#__PURE__*/ _jsx(Typography, {
            variant: "h6",
            children: "소식 받기를 해지하시겠어요? "
        }),
        content: /*#__PURE__*/ _jsx(Typography, {
            color: "text.primary",
            variant: "body1",
            children: "더 이상 브랜드의 신규 상품 업로드나 할인 소식을 받아볼 수 없어요."
        }),
        subContent: /*#__PURE__*/ _jsx(RadioBox, {
            children: /*#__PURE__*/ _jsx(CustomizedRadios, {
                value: value,
                setValue: setValue,
                isError: isError,
                setIsError: setIsError,
                isEtc: isEtc,
                etcReason: etcReason,
                setEtcReason: setEtcReason
            })
        }),
        footer: /*#__PURE__*/ _jsxs(Stack, {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            gap: "8px",
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    variant: "filledSecondary",
                    sx: {
                        padding: "12px 20px"
                    },
                    onClick: ()=>{
                        close();
                        //mx-9
                        mixpanelEvent("Popup Button Clicked", {
                            "Popup Type": "Brand Unsubscription",
                            "Popup Title": "소식 받기를 해지하시겠어요?",
                            "Button Name": "닫기"
                        });
                    },
                    children: "닫기"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "filledPrimary",
                    disabled: value === null,
                    onClick: submit,
                    sx: {
                        padding: "12px 20px"
                    },
                    children: "소식 받지 않기"
                })
            ]
        })
    };
    if (isMobile) return /*#__PURE__*/ _jsx(AnchorDrawer, {
        open: content.open,
        anchor: "right",
        onClose: close,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    variant: "subtitle1",
                    sx: {
                        padding: "16px 20px",
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #F0F1F5",
                        alignItems: "center"
                    },
                    children: [
                        "소식 받기 해지",
                        /*#__PURE__*/ _jsx(Icon, {
                            icon: Close,
                            size: Sizes.small,
                            onClick: close
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Stack, {
                    sx: {
                        padding: "20px",
                        gap: "28px"
                    },
                    children: [
                        content.title,
                        content.content,
                        content.subContent,
                        content.footer
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ _jsx(ConfirmDialog, {
        open: content.open,
        title: content.title,
        content: content.content,
        subContent: content.subContent,
        footer: content.footer,
        onClose: close
    });
};
const RadioBox = styled("div")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        padding: "12px 20px 12px 8px",
        flexDirection: "column",
        alignItems: "flex-start",
        backgroundColor: theme.palette.grey[0],
        borderRadius: "4px"
    };
});
const BpIcon = styled("span")((param)=>{
    let { theme  } = param;
    return {
        borderRadius: "50%",
        width: 16,
        height: 16,
        boxShadow: "inset 0 0 0 2px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
        backgroundColor: "#f5f8fa",
        backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
        ".Mui-focusVisible &": {
            outline: "2px auto rgba(19,124,189,.6)",
            outlineOffset: 2
        },
        "input:hover ~ &": {
            backgroundColor: "#ebf1f5",
            ...theme.applyStyles("dark", {
                backgroundColor: "#30404d"
            })
        },
        "input:disabled ~ &": {
            boxShadow: "none",
            background: "rgba(206,217,224,.5)",
            ...theme.applyStyles("dark", {
                background: "rgba(57,75,89,.5)"
            })
        },
        ...theme.applyStyles("dark", {
            boxShadow: "0 0 0 1px rgb(16 22 26 / 40%)",
            backgroundColor: "#394b59",
            backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        })
    };
});
const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#6950E5",
    boxShadow: "inset 0 0 0 2px #6950E5, inset 0 -1px 0 #6950E5",
    backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&::before": {
        display: "block",
        width: 16,
        height: 16,
        backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
        content: '""'
    },
    "input:hover ~ &": {
        backgroundColor: "#6950E5"
    }
});
// Inspired by blueprintjs
function BpRadio(props) {
    return /*#__PURE__*/ _jsx(Radio, {
        disableRipple: true,
        color: "default",
        checkedIcon: /*#__PURE__*/ _jsx(BpCheckedIcon, {}),
        icon: /*#__PURE__*/ _jsx(BpIcon, {}),
        ...props
    });
}
export default function CustomizedRadios(param) {
    let { value , setValue , isError , setIsError , etcReason , setEtcReason , isEtc  } = param;
    return /*#__PURE__*/ _jsx(FormControl, {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ _jsxs(RadioGroup, {
            value: value,
            onChange: (event)=>setValue(event.target.value),
            "aria-labelledby": "demo-customized-radios",
            name: "customized-radios",
            children: [
                Object.values(CancelReasonValue).map((item)=>/*#__PURE__*/ _jsx(FormControlLabel, {
                        sx: (theme)=>({
                                "& .MuiFormControlLabel-label": {
                                    padding: "8px 0",
                                    color: theme.palette.text.primary,
                                    ...theme.typography.body1
                                },
                                "& .MuiRadio-root": {
                                    padding: "12px"
                                }
                            }),
                        value: item,
                        control: /*#__PURE__*/ _jsx(BpRadio, {}),
                        label: item
                    })),
                isEtc && /*#__PURE__*/ _jsx(Box, {
                    sx: {
                        padding: "0px 0px 8px 40px"
                    },
                    children: /*#__PURE__*/ _jsx(TextField, {
                        sx: {
                            width: "100%"
                        },
                        error: isError,
                        helperText: isError && "반드시 작성이 필요해요.",
                        placeholder: "해지 이유를 작성해 주세요.",
                        value: etcReason,
                        onChange: (e)=>{
                            setEtcReason(e.target.value);
                            setIsError(false);
                        }
                    })
                })
            ]
        })
    });
}
